import Vue from 'vue'
import axios from 'axios'
import store, {
  MUTATION_ON_ERROR,
  MUTATION_RAISE_NOTIFICATION,
  MUTATION_START_LOADING,
  MUTATION_STOP_LOADING,
  MUTATION_SET_MISSING_USER_DATA
} from '@/plugins/store'
import { EVENT_SHOW_COINS_DIALOG, EVENT_SHOW_ONLINE_IDS_DIALOG, EVENT_SHOW_PREMIUM_OPTIONS } from '@/plugins/eventbus'
import router from '@/plugins/router'
import appDataset from '@/plugins/appDataset'

let client = axios.create({
  baseURL: '/',
})

client.interceptors.request.use(function (config) {
  store.commit(MUTATION_START_LOADING)
  if (router.currentRoute.query.s) {
    config.headers['X-Secret'] = router.currentRoute.query.s
  }
  if (appDataset.tenant) {
    config.headers['X-Tenant'] = appDataset.tenant
  }
  return config
})

client.interceptors.response.use(
  function (response) {
    store.commit(MUTATION_STOP_LOADING);
    return response
  },
  function (error) {
    store.commit(MUTATION_STOP_LOADING);
    store.commit(MUTATION_ON_ERROR, error);
    var moreInfo = '';
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400: // Ignore on bad-request
        case 401: // Ignore on unauthenticated
          break;
        default:
          moreInfo += ' (' + error.response.status + ')'
          break;
        }
    }
    if (error.config && error.config._custom) {
      if (error.config._custom.suppressNotifications === true) {
        // do not raise any notifications
        throw error;
      }
    }

    if (error.response) {
      var message = error.response.data.errors ?
        Object.values(error.response.data.errors).reduce((acc, val) => acc + val, error.response.data.message + ' ') :
        error.response.data.message;
      if (!message || message == "") {
        message = error.response.statusText;
      }
      var notificationAction = undefined;
      // Handle response error
      let code = error.response.data.code;
      if (code) {
        if (code == 'PARTICIPATING_AT_TOO_MANY_COMPETITIONS') {
          notificationAction = {
            label: 'Premium ...',
            event: EVENT_SHOW_PREMIUM_OPTIONS,
            icon: 'mdi-star-circle-outline'
          }
        } else if (code == 'ONLINE_ID_FOR_PLATFORM_REQUIRED' || code == 'ONLINE_ID_FOR_PLATFORM_AND_GAME_REQUIRED') {
          notificationAction = {
            label: 'Online-ID einpflegen',
            event: EVENT_SHOW_ONLINE_IDS_DIALOG,
            icon: 'mdi-account'
          }
        } else if (code == 'INSUFFICIENT_COINS') {
          notificationAction = {
            label: 'Coins kaufen',
            icon: 'mdi-circle-multiple-outline',
            event: EVENT_SHOW_COINS_DIALOG
          }
        } else if (code == 'ADDITIONAL_USER_DATA_REQUIRED') {
          if(!window.location.href.endsWith('/complete-user-data')) {
            router.push('/complete-user-data')
          }
          store.commit(MUTATION_SET_MISSING_USER_DATA, {missingFields: error.response.data.missingFields})

          return
        }
      }
      store.commit(MUTATION_RAISE_NOTIFICATION, {
        type: 'error',
        message: message + moreInfo,
        action: notificationAction,
        status: error.response.status,
        details: error.response.data
      })
    } else if (error.message) {
      store.commit(MUTATION_RAISE_NOTIFICATION, {
        type: 'error',
        message: error.message + moreInfo,
        status: -1,
        details: null
      })
    }
    throw error
  })

Vue.prototype.$http = client

export default client
